import { safeRelativeReturnPath } from "./auth-identity.ts";

export const CLOUDFLARE_ACCESS_REAUTH_PATH = "/api/auth/access/relogin";

export const CLOUDFLARE_ACCESS_ERROR_CODES = {
  loginRequired: "ACCESS_LOGIN_REQUIRED",
  sessionExpired: "ACCESS_SESSION_EXPIRED",
  notConfigured: "ACCESS_NOT_CONFIGURED",
} as const;

export function needsCloudflareAccessReauthentication(code: unknown) {
  return code === CLOUDFLARE_ACCESS_ERROR_CODES.loginRequired
    || code === CLOUDFLARE_ACCESS_ERROR_CODES.sessionExpired;
}

export function cloudflareAccessReauthenticationPath(returnTo = "/") {
  return `${CLOUDFLARE_ACCESS_REAUTH_PATH}?return_to=${encodeURIComponent(safeRelativeReturnPath(returnTo))}`;
}

export function googleSignInPath(returnTo = "/") {
  return `/api/auth/google?return_to=${encodeURIComponent(safeRelativeReturnPath(returnTo))}`;
}

export function identitySignOutPath(returnTo = "/") {
  return `/api/auth/logout?return_to=${encodeURIComponent(safeRelativeReturnPath(returnTo))}`;
}

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  access_denied: "Google 登录已取消，请重新尝试。",
  invalid_callback: "Google 登录回调已失效，请重新开始登录。",
  login_failed: "Google 身份验证失败，请稍后重试。",
  not_invited: "这个 Google 邮箱不在家庭成员访问名单中。",
  not_configured: "本地 Google 登录尚未配置，请先填写开发环境密钥。",
  session_unavailable: "身份会话密钥尚未配置，暂时无法登录。",
};

export function authErrorMessage(value: string | string[] | undefined) {
  const code = Array.isArray(value) ? value[0] : value;
  return code ? AUTH_ERROR_MESSAGES[code] ?? null : null;
}
